module.exports = __webpack_public_path__ + "img/garde.2a94feb7.jpg";